"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getActionBannerUtilityClass = getActionBannerUtilityClass;
var _mui = require("@ori-ui/mui");
function getActionBannerUtilityClass(slot) {
  return (0, _mui.generateUtilityClass)('ActionBanner', slot);
}
const actionBannerClasses = (0, _mui.generateUtilityClasses)('ActionBanner', ['root', 'content', 'contentHover', 'focusVisible', 'disabled']);
var _default = exports.default = actionBannerClasses;
